import { useEffect, useState } from 'react';
import devLogger from 'react-utils/devLogger';
// eslint-disable-next-line no-restricted-imports
import userInfo, { userInfoSync } from 'hub-http/userInfo';

// This is lifted from customer-data-properties: https://git.hubteam.com/HubSpot/customer-data-properties/blob/master/customer-data-properties/static/js/v2/hooks/useUserInfo.ts
export const useUserInfo = () => {
  const [userInfoResponse, setUserInfoResponse] = useState(() => {
    /*
     * Initialize with userInfoSync in case userInfo has already been loaded.
     * this avoids an initial render without gates/scopes, if possible.
     * userInfoSync throws an Error if userInfo has not finished loading yet;
     * in that case fall back to waiting for async userInfo
     */
    try {
      return userInfoSync();
    } catch (__error) {
      devLogger.warn({
        message: `meetingslib-userinfosync: Failure reading userinfo sync`,
        key: 'meetingslib-userinfosync'
      });
    }
    return undefined;
  });
  useEffect(() => {
    if (userInfoResponse) {
      return;
    }
    try {
      /*
       * ignoreRedirect is important! Without it, any consumers that don't
       * support or shim userInfo can end up redirecting (the default behavior).
       */
      userInfo({
        ignoreRedirect: true
      }).then(response => {
        setUserInfoResponse(response);
      }).catch(() => {
        devLogger.warn({
          message: `meetingslib-userinfo: API failure fetching userinfo`,
          key: 'meetingslib-userinfo-api'
        });
      });
    } catch (err) {
      devLogger.warn({
        message: `meetingslib-userinfo: Failure fetching userinfo`,
        key: 'meetingslib-userinfo'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return userInfoResponse;
};